import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTermsAndConditions, updateTermsAndConditionsThunk } from "../../slices/staticPages/thunk";
import { resetTermsAndConditionsFlag } from "../../slices/staticPages/reducer";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";

function TermsAndCondition() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const termsAndConditions = state?.StaticPages?.termsPolicy || {};
  const [editorData, setEditorData] = useState("");

  useEffect(() => {
    dispatch(fetchTermsAndConditions());
  }, [dispatch]);

  useEffect(() => {
    if (termsAndConditions?.data?.htmlContent) {
      setEditorData(termsAndConditions.data.htmlContent);
    }
  }, [termsAndConditions?.data?.htmlContent]);

  const handleSave = () => {
    dispatch(updateTermsAndConditionsThunk({ htmlContent: editorData }));
  };

  useEffect(() => {
    if (termsAndConditions?.success) {
      const timer = setTimeout(() => dispatch(resetTermsAndConditionsFlag()), 3000);
      return () => clearTimeout(timer);
    }
  }, [termsAndConditions?.success, dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Terms & Conditions" pageTitle="Terms & Conditions" />
        </Container>
      </div>

      <div className="static-page"
        style={{
          marginBottom: "55px",
          background: "white",
          padding: "1rem",
        }}
      >
        <label className="form-label fw-bold">HTML Content</label>

        {/* CKEditor */}
        <div className="border p-2">
          <CKEditor
            editor={ClassicEditor}
            data={editorData || ""}
            onChange={(event, editor) => {
              try {
                setEditorData(editor.getData());
              } catch (e) {
                console.error("Editor error:", e);
              }
            }}
          />
        </div>

        <button
          className="btn btn-primary mt-3"
          disabled={termsAndConditions?.loading}
          onClick={handleSave}
        >
          {termsAndConditions?.loading ? "Saving..." : "Save"}
        </button>

        {termsAndConditions?.success && (
          <div className="alert alert-success mt-3">{termsAndConditions.success}</div>
        )}
        {termsAndConditions?.error && (
          <div className="alert alert-danger mt-3">{termsAndConditions.error}</div>
        )}

        {/* Preview */}
        <h5 className="form-label fw-bold mt-4">Preview</h5>
        <div
          style={{
            border: "1px solid #ccc",
            padding: "15px",
            borderRadius: "4px",
            minHeight: "100px",
          }}
          dangerouslySetInnerHTML={{ __html: editorData || "" }}
        />
      </div>
    </React.Fragment>
  );
}

export default TermsAndCondition;
